import { render, staticRenderFns } from "./recipientCheck.vue?vue&type=template&id=593936b8&scoped=true&"
import script from "./recipientCheck.vue?vue&type=script&lang=js&"
export * from "./recipientCheck.vue?vue&type=script&lang=js&"
import style0 from "./recipientCheck.vue?vue&type=style&index=0&id=593936b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593936b8",
  null
  
)

export default component.exports